import { Fragment, useState } from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import {
  DvrOutlined,
  Diversity2Outlined,
  Healing,
  HomeOutlined,
  LocalPharmacyOutlined,
  DriveFileRenameOutline,
  MedicationOutlined,
  ImageOutlined,
  TaskOutlined,
  SentimentSatisfiedOutlined,
  RestaurantMenu,
  VerifiedUserOutlined,
  ExpandMore,
  MonitorHeartOutlined,
  MasksOutlined,
  SickOutlined,
  ErrorOutlineOutlined,
  VideocamOutlined,
  PsychologyOutlined,
  AutorenewOutlined,
} from '@mui/icons-material';
import { AiOutlineCalculator } from 'react-icons/ai';

import Survey from '../Survey';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import useNotification from 'hooks/useNotification';
import { IToggleObj } from './type';
import { initialToggleObj } from './initialStates';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
  coachRef: any;
}

const MenuRecords = (props: Props) => {
  const { menuDrawerWidth, setMenuDrawerWidth, coachRef } = props;

  const { student_uuid } = useStudent();
  const { patientInfo } = usePatient();
  const { onRequired } = useNotification();
  const { onUpdateSurveyType } = useSurvey();

  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);

  const menus = [
    {
      icon: <DvrOutlined />,
      label: 'e-Кардех',
    },
    {
      disabled: true,
      icon: <AutorenewOutlined />,
      label: 'SBAR',
      id: 'sbar',
    },
    {
      label: 'SBAR 1',
      toggle: toggle.sbar,
    },
    // {
    //   label: 'SBAR 2',
    //   toggle: toggle.sbar,
    // },
    // {
    //   label: 'SBAR 3',
    //   toggle: toggle.sbar,
    // },
    {
      icon: <Diversity2Outlined />,
      label: 'Сувилагч шилжүүлэх',
    },
    {
      icon: <Healing />,
      label: 'Хэвтэн эмчлүүлэгчийн бүртгэл',
    },
    {
      icon: <HomeOutlined />,
      label: 'Гаралтын бүртгэл',
    },
    {
      icon: <LocalPharmacyOutlined />,
      label: 'Өвчтөний байдал, жор',
    },
    {
      icon: <DriveFileRenameOutline />,
      label: 'Сувилахуйн тэмдэглэл',
    },
    {
      icon: <MedicationOutlined />,
      label: 'Эмийн тэмдэглэл',
    },
    {
      icon: <ImageOutlined />,
      label: 'Рентген бичлэг',
    },
    {
      icon: <TaskOutlined />,
      label: 'Клиникийн эмгэг судлал',
    },
    {
      disabled: true,
      icon: <MonitorHeartOutlined />,
      label: 'Клиникийн ажиглалтын бүртгэл',
      id: 'clinical_obv',
    },
    {
      label: 'Амин чухал шинж тэмдэгийн бүртгэл',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'I/O',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'Цусан дахь сахар хэмжих бүртгэл',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'Клиникийн ажиглалтын бүртгэл (ЭМТ)',
      toggle: toggle.clinical_obv,
    },
    {
      disabled: true,
      icon: <SentimentSatisfiedOutlined />,
      label: 'Өвчтөний үнэлгээ',
      id: 'patient_evaluation',
    },
    {
      label: 'Морсийн уналтын масштаб',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Хампти Дампти уналтын масштаб',

      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Брадены масштаб',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Хэрэгцээний үнэлгээ',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'GCS',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Хүүхдийн GCS',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Дөрвөн оноо (FOUR)',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Өвчтөний аюулгүй байдлын тайлан',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Өвчтөний аюулгүй байдлын тайлангийн болон суралцах систем',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Эмийн сөрөг үйлдлийн тайлангийн систем',
      toggle: toggle.patient_evaluation,
    },

    {
      icon: <SickOutlined />,
      disabled: true,
      label: 'Өвдөлтийн үнэлгээ',
      id: 'pain',
    },
    {
      label: 'NRS',
      toggle: toggle.pain,
    },
    {
      label: 'FLACC Scale',
      toggle: toggle.pain,
    },
    // {
    //   label: 'CNPS',
    //   toggle: toggle.pain,
    // },
    {
      label: 'FFI',
      toggle: toggle.pain,
    },
    {
      label: 'KOOS',
      toggle: toggle.pain,
    },
    {
      label: 'LEFS',
      toggle: toggle.pain,
    },
    {
      label: 'NDI',
      toggle: toggle.pain,
    },
    {
      label: 'Нурууны өвдөлтийн үнэлгээний дэлгэцийн тест',
      toggle: toggle.pain,
    },
    {
      icon: <PsychologyOutlined />,
      disabled: true,
      label: 'Сэтгэцийн эрүүл мэнд',
      id: 'mental_health',
    },
    {
      label: 'Сэтгэцийн эрүүл мэндийн бүртгэл',
      toggle: toggle.mental_health,
    },
    {
      label: 'BDI',
      toggle: toggle.mental_health,
    },
    {
      label: 'BAI',
      toggle: toggle.mental_health,
    },
    {
      label: 'MMSE',
      toggle: toggle.mental_health,
    },
    {
      disabled: true,
      icon: <MasksOutlined />,
      label: 'Онцгой бүртгэл',
      id: 'special',
    },
    {
      label: 'Мэс заслын бүртгэл',
      toggle: toggle.special,
    },
    {
      label: 'Мэдээ алдуулалтын бүртгэл',
      toggle: toggle.special,
    },
    {
      label: 'Цус сэлбэлтийн бүртгэл',
      toggle: toggle.special,
    },
    {
      label: 'Төгсөлтийн бүртгэл',
      toggle: toggle.special,
    },
    {
      label: 'CPR',
      toggle: toggle.special,
    },
    {
      label: 'Диализийн бүртгэл',
      toggle: toggle.special,
    },
    {
      label: 'Яаралтай тусламжийн бүртгэл',
      toggle: toggle.special,
    },
    {
      label: 'Төрөхийн бүртгэл',
      toggle: toggle.special,
    },
    {
      label: 'Гэрийн асаргааны бүртгэл',
      toggle: toggle.special,
    },
    {
      icon: <RestaurantMenu />,
      label: 'Хоол тэжээлийн бүртгэл',
    },
    {
      disabled: true,
      icon: <VerifiedUserOutlined />,
      label: 'зөвшөөрөл',
      id: 'agreement',
    },
    {
      label: 'Өвчтөний гарын авлага',
      toggle: toggle.agreement,
    },
    {
      label: 'Өвчтөний зөвшөөрлийн маягт',
      toggle: toggle.agreement,
    },
    {
      label: 'Цус сэлбэлтийн зөвшөөрөл',
      toggle: toggle.agreement,
    },
    {
      label: 'хаантай мэдээ алдуулалтын зөвшөөрөл',
      toggle: toggle.agreement,
    },
    {
      label: 'DNR',
      toggle: toggle.agreement,
    },
    {
      label: 'Эмнэлэгт хэвтэх гэрээ',
      toggle: toggle.agreement,
    },
    {
      label: 'Эмнэлэгт хэвтэх гарын авлага',
      toggle: toggle.agreement,
    },
    {
      label: 'Эмнэлэгт хэвтэх шалгах жагсаалт',
      toggle: toggle.agreement,
    },
    {
      label: 'Уналтаас сэргийлэх',
      toggle: toggle.agreement,
    },
    {
      label: 'CRRT',
      toggle: toggle.agreement,
    },
    {
      label: 'Төв венийн катетер тавих',
      toggle: toggle.agreement,
    },
    {
      label: 'ETI',
      toggle: toggle.agreement,
    },
    {
      label: 'Бие махбодын хязгаарлалт',
      toggle: toggle.agreement,
    },
    {
      disabled: true,
      icon: <ErrorOutlineOutlined />,
      label: 'Мэдээлэлзүй ба сувилахуйн үйл ажиллагаа',
      id: 'information',
    },
    {
      label: 'Chat GPT',
      toggle: toggle.information,
    },
    {
      label: 'Google Gemini',
      toggle: toggle.information,
    },
    {
      label: 'Cochranelibrary',
      toggle: toggle.information,
    },
    {
      label: 'JBI',
      toggle: toggle.information,
    },
    {
      label: 'DXPLAIN',
      toggle: toggle.information,
    },
    {
      label: 'Patientslikeme',
      toggle: toggle.information,
    },
    {
      label: 'Smartpatients',
      toggle: toggle.information,
    },
    {
      label: 'AI сувилахуйн тэмдэглэл',
      toggle: toggle.information,
    },
    {
      icon: <VideocamOutlined />,
      label: 'Видео байршуулах',
    },
    {
      icon: <AiOutlineCalculator />,
      label: 'Эмийн тун тооцоолуур',
    },
  ];

  const onClickListItem = (label: string) => {
    // if (!student_uuid) return onRequired('REQUIRED.STUDENT');

    if (label === 'Өвчтөний аюулгүй байдлын тайлангийн болон суралцах систем') {
      window.open('https://psnet.ahrq.gov/');
      return;
    } else if (label === 'Эмийн сөрөг үйлдлийн тайлангийн систем') {
      window.open('https://who-umc.org/');
      return;
    } else if (label === 'Chat GPT') {
      window.open('https://chat.openai.com/chat');
      return;
    } else if (label === 'Google Gemini') {
      window.open('https://bard.google.com/');
      return;
    } else if (label === 'Cochranelibrary') {
      window.open('https://www.cochranelibrary.com/');
      return;
    } else if (label === 'JBI') {
      window.open('https://jbi.global/');
      return;
    } else if (label === 'DXPLAIN') {
      window.open('https://www.mghlcs.org/projects/dxplain');
      return;
    } else if (label === 'Patientslikeme') {
      window.open('https://www.patientslikeme.com/');
      return;
    } else if (label === 'Smartpatients') {
      window.open('https://www.smartpatients.com/');
      return;
    } else if (label === 'AI сувилахуйн тэмдэглэл') {
      window.open('https://chatbot2-enr-mn.streamlit.app/');
      return;
    }
    // if (!patientInfo) return onRequired('REQUIRED.PATIENT');
    onUpdateSurveyType(label);
  };

  const onClickDisabledItem = (sublabel: string | undefined) => {
    let newToggle = { ...toggle };

    if (menuDrawerWidth !== 220) {
      if (sublabel) newToggle[sublabel] = true;
      setToggle(newToggle);
      setMenuDrawerWidth(220);
      return;
    }

    if (sublabel) newToggle[sublabel] = !newToggle[sublabel];
    setToggle(newToggle);
  };

  return (
    <Fragment>
      {menus.map(({ icon, label, disabled, toggle, id }) => {
        const onClick = () => {
          if (disabled) onClickDisabledItem(id);
          else onClickListItem(label);
        };

        const MoreIcon = () => {
          if (!disabled) return null;
          return (
            <ExpandMore
              fontSize="small"
              sx={{ color: '#fff', marginRight: '-8px' }}
            />
          );
        };

        // 축소된 메뉴 (52px)
        if (menuDrawerWidth !== 220) {
          if (!icon) return null;

          return (
            <Tooltip
              key={label}
              title={label}
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                    padding: '8px 12px',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                  },
                },
                arrow: {
                  sx: {
                    color: 'rgba(0, 0, 0, 0.9)',
                  },
                },
              }}
            >
              <ListItem disablePadding>
                <ListItemButton onClick={onClick}>
                  <ListItemIcon>{icon}</ListItemIcon>
                </ListItemButton>
              </ListItem>
            </Tooltip>
          );
        }

        // 확장된 메뉴 (220px)
        if (icon) {
          return (
            <ListItem
              key={label}
              disablePadding
              ref={label === 'Special part Record' ? coachRef : null}
              sx={{ whiteSpace: 'pre-wrap' }}
            >
              <ListItemButton onClick={onClick}>
                <ListItemIcon sx={{ margin: '6.5px 0 6px 0' }}>
                  {icon}
                </ListItemIcon>
                <ListItemText sx={{ margin: '6.5px 0 0 0' }} primary={label} />
                <MoreIcon />
              </ListItemButton>
            </ListItem>
          );
        }

        if (toggle) {
          return (
            <ListItem key={label} disablePadding sx={{ width: '200px' }}>
              <ListItemButton onClick={onClick}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={label} sx={{ whiteSpace: 'pre-wrap' }} />
                <MoreIcon />
              </ListItemButton>
            </ListItem>
          );
        }

        return null;
      })}

      <Survey />
    </Fragment>
  );
};

export default MenuRecords;
